(function trackerHousingMarkets() {
  'use strict';

  const houseMarketsContainer = document.querySelector('#nhs_HouseMarkets');
  const amenitiesLinks = document.querySelectorAll('[data-amenity-card] a');

  /**
   * @private
   * housingLinkClick: track event when housing anchor is clicked.
   *
   * @param {Event} event with the click information.
   */
  function housingLinkClick(event) {
    const target = event.target;

    if (target.tagName !== 'A') {
      return;
    }

    const eventGa4 = {
      eventName: 'site_links',
      params: {
        position: 'New homes in markets',
        click_target: target.innerText,
        destination: target.href
      },
      eventType: 'GA4Event'
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
  }

  /**
   * @private
   * amenityLinkClick: track event when amenity anchor is clicked.
   *
   * @param {Event} event with the click information.
   */
  function amenityLinkClick(event) {
    const target = event.target;
    if (target.tagName !== 'A') {
      return;
    }

    const eventGa4 = {
      eventName: 'amenities_search',
      params: {
        position: 'special real estate communities',
        click_target: this.index + 1,
        destination: target.href
      },
      eventType: 'GA4Event'
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: eventGa4 }
    }));
  }

  /**
   * @private
   * addListenerAmenityLink: add event to amenity link.
   *
   * @param {Node} element to attach the listener.
   * @param {Number} index position of the element in the array.
   */
  function addListenerAmenityLink(element, index) {
    element.addEventListener('click', amenityLinkClick.bind({
      index
    }));
  }

  if (houseMarketsContainer) {
    houseMarketsContainer.addEventListener('click', housingLinkClick);
  }

  amenitiesLinks.forEach(addListenerAmenityLink);
}());

define("trackerHousingMarkets", function(){});

